import { Injectable } from '@angular/core';

@Injectable()

export class ConstantSeoPages {

  SEO_PAGES = new Array<string> ('login');

}
